import { useEffect, useState } from 'react'
import { AspenOrdersService, PaginatedDTO_OrderDTO_ } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

export const usePatientOrders = (patientId?: string) => {
    const [orders, setOrders] = useState<PaginatedDTO_OrderDTO_ | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        let isMounted = true

        const fetchOrders = async () => {
            setLoading(true)
            setError(null)
            try {
                const response: CancelablePromise<PaginatedDTO_OrderDTO_> = AspenOrdersService.indexOrdersGet({ patientId })
                const data = await response
                if (isMounted) {
                    setOrders(data)
                }
            } catch (err) {
                if (isMounted) {
                    setError('Failed to fetch orders data')
                }
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        fetchOrders()

        return () => {
            isMounted = false
        }
    }, [patientId])

    return { orders, loading, error }
}
